// apiService.ts
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import axiosInstance from "./axios";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { dayJsDate } from "@/utils/common";
import { toast } from "react-toastify";
export const getAppointmentsByDate = async (userId, repId, date) => {
  console.log("USER_APP", userId, repId, date);
  const response = await axiosInstance.post(`/appointments/appointments-availability/provider/${repId}/${userId}`, {
    date: date
  });
  return response.data;
};
const useAppointmentAvailability = ({
  repId = null,
  userId = null,
  date
}) => {
  if (!userId && !repId) {
    const users = useSelector(state => state?.userData?.userData?.user);
    console.log(users?._id, 'useAvailability');
    userId = users?._id;
  }
  const appointmentAvailabilityProvider = useQuery({
    queryKey: ["appointments_availability_provider", date, userId, repId],
    queryFn: () => getAppointments(userId, repId, date),
    enabled: userId != null || repId != null
  });
  return {
    appointmentAvailabilityProvider
  };
};
export default useAppointmentAvailability;